export const fileUploadPrefixes = {
  presentations: "presentations",
  showrooms: "showrooms",
  coverpages: "coverpages",
  microsites: "microsites",
  presentationStudioThumbnail: "showroompresentation-JUo2mM"
};
